import React from 'react'
import { useForm, FormProvider } from 'react-hook-form';
import {Input, DateInput, Radio, Select } from '@components';

const BoardPage = () => {

const methods = useForm({
    defaultValues: {
        searchCnd: '', 
        searchWrd: '',
        exm: '',
        createStDate: '',
        createEndDate: '',
    }
});

const { watch } = methods;

const searchCndOptions = [
    { key: "0", name: "배정강사" },
    { key: "1", name: "과정명" },
];



 return (
<FormProvider {...methods}>
<div className="contents-wrap">

    <div className="page-title-wrap">
        <h2><span className="icon-dot-circle"></span>안전법규및규정</h2>
    </div>

    <div className="tab-wrap">
        <ul>
            <li id="tabBtn1" className="on"><a href="/" title="산업안전보건법">산업안전보건법</a></li>
            <li id="tabBtn4"><a href="/" title="안전보건관계법령">안전보건관계법령</a></li>
            <li id="tabBtn2"><a href="/" title="중대재해처벌법">중대재해처벌법</a></li>
            <li id="tabBtn3"><a href="/" title="사내안전보건관리규정">사내안전보건관리규정</a></li>
        </ul>
    </div>

    <div className="tab-cont-wrap">
        <div className="tab-cont-01 on">

            <div className="search-wrap">
                <div className="search-row">
                        <div className="search-item date-picker-box">
                            <label>등록일</label>
                            <DateInput name="createStDate" />
                            <span className="separator">~</span>
                            <DateInput name="createEndDate" minDate={watch("createStDate")} />
                        </div>
                    <div className="search-item">
                        <Radio label="예시1번" name="exm" value="e1" />
                        <Radio label="예시2번" name="exm" value="e2" className="ml10" />
                    </div>
                    <div className="search-item">
                        <Select
                            name="searchCnd"
                            options={searchCndOptions}
                            defaultOption="선택"
                            className="input-select"
                        />
                        <Input
                            name="searchWrd"
                            placeholder="검색어를 입력하세요"
                            className="input-search"
                            style={{width:'250px'}}
                        />
                    </div>
                    <div className="search-btn-container">
                        <button className="btn-search">조회</button>
                    </div>
                </div>
            </div>


            <div className="row-1">
                <section className="wp60">
                    <div className="section-tit-wrap">
                        <h3 className='border-left-primary'>
                            &nbsp;산업안전보건법<span className="total-txt"> | 총 <span className='red'>10</span> 건
                            </span>
                        </h3>
                        <div className="btn-right-box">
                            <ul>
                                <li><button type="button" title="삭제" className="btn-delete" id="btn-delete01">삭제</button></li>
                            </ul>
                        </div>
                    </div>
                    <table className="table-list">
                        <colgroup>
                        <col style={{ width: '5%' }} />
                        <col style={{ width: '10%' }}/>
                        <col style={{ width: '40%' }} />
                        <col style={{ width: '15%' }}/>
                        <col style={{ width: '15%' }}/>
                        </colgroup>
                        <thead>
                            <tr>
                                <th><input type="checkbox" /></th>
                                <th>번호</th>
                                <th>제목</th>
                                <th>등록일</th>
                                <th>조회수</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td><input type="checkbox" /></td>
                                <td>1</td>
                                <td>제목테스트트트트트</td>
                                <td>2024-12-21</td>
                                <td>1</td>
                            </tr>
                            <tr>
                                <td><input type="checkbox" /></td>
                                <td>2</td>
                                <td>산업안전전</td>
                                <td>2024-12-21</td>
                                <td>1</td>
                            </tr>
                            <tr>
                                <td><input type="checkbox" /></td>
                                <td>3</td>
                                <td>관리감독자</td>
                                <td>2024-12-21</td>
                                <td>1</td>
                            </tr>
                            <tr>
                                <td><input type="checkbox" /></td>
                                <td>4</td>
                                <td>1</td>
                                <td>1</td>
                                <td>1</td>
                            </tr>
                        </tbody>
                    </table>
                </section>


                <section className="wp40">

                    <div className="section-tit-wrap">
                        <h3 className='border-left-primary'>&nbsp;산업안전보건법상세</h3>
                        <div className="btn-right-box">
                            <ul>
                                {/* <li><a href="/" title="작성" className="btn-add" id="btn-add01" >작성</a></li> */}
                                <li><button type="button" title="저장" className="btn-save" id="btn-save01">저장</button></li>
                            </ul>
                        </div>
                    </div>


                    <table className="table-write">
                        <colgroup>
                            <col style={{ width: '20%' }} />
                            <col style={{ width: '30%' }}/>
                            <col style={{ width: '20%' }} />
                            <col style={{ width: '30%' }}/>
                            </colgroup>
                        <tbody id="tblBody1">
                            <tr>
                                <th>등록일<span className="red">*</span></th>
                                <td colSpan="3">
                                <input
                                    type="date"
                                    placeholder="연도-월-일"
                                    className="input-date"
                                    {...methods.register("regStartDate")}
                                />
                                </td>
                            </tr>
                            <tr>
                                <th>등록자<span className="red">*</span></th>
                                <td colSpan="3">
                                    <div className="input-btn-wrap">
                                    <Input
                                        name="register"
                                        placeholder="등록자 선택하세요."
                                        divStyle={{width:'calc(100% - 95px)'}}
                                        readonly
                                    />
                                    <button type="button" className="btn-select btn-add">선택</button>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </section>
            </div>
        </div>

    </div>
</div>
</FormProvider>
 );
}

export {BoardPage};